<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="pembina_ekskul"
        slot-scope="props">
        <div
          v-for=" (item, index) in props.row.pembina_ekskul"
          :key="index">
          <div>- {{ item.nama_pegawai }}</div>
        </div>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalAnggota"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">List Anggota {{ nameEkskul }}</h2>

      <v-client-table
        :data="list_anggota"
        :columns="columns_anggota"
        :options="options_anggota"
        class="jTable" />

      <div class="float-to-right m__t--20">
        <b-button
          class="btn gray"
          @click="closeModal">
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Report Ekstrakulikuler',
      },
      load_first: false,
      data_table: [],
      columns: ['tahunajaran', 'name', 'pembina_ekskul', 'total'],
      options: {
        headings: {
          tahunajaran: 'TAHUN PELAJARAN',
          name: 'NAMA EKSKUL',
          pembina_ekskul: 'NAMA PEMBINA',
          total: 'JUMLAH ANGGOTA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 100,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : '',
              ascending: !!data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListTahunEkskul(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
      nameEkskul: '',

      list_anggota: [],
      columns_anggota: ['kode', 'kode_kelas', 'nama_kelas', 'nis', 'nama_siswa', 'tahunajaran'],
      options_anggota: {
        headings: {
          kode: 'Kode Ekskul',
          kode_kelas: 'Kode Kelas',
          nama_kelas: 'Nama Kelas',
          nis: 'NIS',
          nama_siswa: 'Nama Siswa',
          tahunajaran: 'Tahun Ajaran',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['getListAnggota']),

    loading(val) {
      const a = val;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    clickDetail({ row }) {
      this.nameEkskul = row.name;
      this.showLoading();
      const paramAnggota = {
        kode_ekskul: row.kode,
        tahunajaran: row.tahunajaran,
      };
      this.getListAnggota(paramAnggota).then((res) => {
        this.hideLoading();
        this.list_anggota = res.data.data;
      });
      this.$refs.modalAnggota.show();
    },

    closeModal() {
      this.$refs.modalAnggota.hide();
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/ekskul/jEkskulReport.vue